module.exports = __webpack_public_path__ + "static/media/discord.52a5246d.webp";